<template>
  <article class="info_table" style="margin-left:-6%; min-width: 0; height: 232px;">
    <div style="width:35%;margin-left:3%;margin-top:42px;margin-bottom:30px"  class="search_input">
          <input style="width:100%" type="text" id="myInput" @input="search()" placeholder="Buscar...">
          <img style="margin-left:-20px" src="./../../assets/img/icons/search.svg">
      </div>
    <div class="client_table__modal" style="overflow-y: hidden;">
      
      <div v-for="(client,i) in activeClients" :style="allAlarms!=null&&allAlarms.indexOf(client.id.toString())>=0?'background-color:'+actualColor+';':''" :class="'active-clients'" :key="i" class="client_table__modal--card" @click="clickOnCard(client.id)"  >
        <h4 class="client_table__text--title"><b>{{client.name.toUpperCase()}}</b></h4>
        <p class="client_table__text--data"><small><b>{{client.city}}</b></small></p>
        <div class="notification" :class="'active'" >{{client.notifications}}</div>
        <!-- :class="{'active':notifications.newuser!='0'}" -->
      </div>
      
     
      <small v-if="activeClients.length == 0" style="text-align: center; margin-top:33px">
        No se han encontrado clientes con esos criterios de busqueda.
      </small>
    </div>
    
  </article>
</template>

<script>
import moment from 'moment';
export default {
  props:{
    name:{
      type: String,
    },    
  },
  data() {
    return{
      clients:[],
      allAlerts:[],
      myClients:[],
      routePath: this.$route.path,
      allAlarms:[],
      actualColor:"crimson",
      myInterval:null,
    }
  },
  methods:{
    search(){

      //Método para buscar en la tabla por ID.
      
      // Declare variables 
      var input, filter, table, tr, tds, i, txtValue;
      input = document.getElementById("myInput");
      filter = input.value.toLowerCase();
      
      
      var actualItems=[]
      for(var element in this.clients){

        var myRow=JSON.stringify(this.clients[element]).toLowerCase();
        if(myRow.indexOf(filter)>=0){
          actualItems.push(this.clients[element]);
        }

      }
      this.myClients=actualItems;
    },
    // myCardStyle(id){
    //   let style="";
    //   console.log(this.actualColor);
    //   if(){

    //     style="background:"+this.actualColor+";"
    //   } 
    //   return style;
    // },
    clickOnCard(id){

      if(this.allAlarms!=null&&this.allAlarms.indexOf(id.toString())>=0){
        delete this.alerts[id.toString()]
        localStorage.setItem("urgent_alerts",JSON.stringify(this.alerts));
        let myNotifications=Object.values(this.alerts).reduce((a, b) => a + b, 0);
        localStorage.setItem("importantNotifications",myNotifications);
      } 
      this.$router.push({ path: this.routePath + '/' + id });
    }
  },
  computed: {
    activeClients(){
      return this.myClients.filter(function(element){
        return element.notifications>0
      })
    },
    
  },
  
  created(){     
    this.alerts=JSON.parse(localStorage.getItem('urgent_alerts'));
    if(this.alerts!=undefined){
    this.allAlarms= Object.keys(this.alerts);
    }else{this.allAlarms=[]}
    const customActions={
        get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
    };
    var card=JSON.parse(localStorage.getItem("user")).id_card;    
    this.$resource('company/new',{},customActions).get({"id_card":card})
    .then(function(data){
      this.clients=data.body;
      this.myClients=this.clients;
    });
    self=this;
    this.myInterval=setInterval(function(){
        if(self.actualColor=="white"){
          self.actualColor="lightpink;"}
        else if(self.actualColor=="lightpink;"){
          self.actualColor="crimson"
        }else if(self.actualColor=="crimson"){
          self.actualColor="lightpink;";
        }
        else{self.actualColor="white"}
    }, 1000);

  },
  destroyed(){
    clearInterval(this.myInterval);
  }
 
}
</script>


// WEBPACK FOOTER //
// src/components/shared/ClientTable.vue